import Module from './Module';

const module = new Module('clients', '/api/v1/clients');

export const {
  get, getById, remove, resetState,
} = module;

export default module.reducer;



// WEBPACK FOOTER //
// ./src/modules/clients.js